import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { Nav, NavItem } from 'react-bootstrap';

import JobInvoiceInbox from './JobInvoiceInbox';
import DeferredJobInbox from './DeferredJobInbox';
import { viewJobs, viewDeferredJobs } from '../actions';
import SageJobsExporter from './SageJobsExporter';
import JobInvoiceInboxLegend from '../components/JobInvoiceInboxLegend';


const JOBS_TAB_KEY = 'JOBS_TAB_KEY';
const DEFERRED_JOBS_TAB_KEY = 'DEFERRED_JOBS_TAB_KEY';


const propTypes = exact({
  activeTab: PropTypes.string.isRequired,
  jobView: PropTypes.bool.isRequired,
  deferredJobView: PropTypes.bool.isRequired,
  viewJobsAction: PropTypes.func.isRequired,
  viewDeferredJobsAction: PropTypes.func.isRequired,
});


const InvoiceInbox = (props) => {
  const {
    activeTab,
    jobView,
    deferredJobView,
    viewJobsAction,
    viewDeferredJobsAction,
  } = props;

  return (
    <div>
      <div className="panel panel-default">
        <div className="panel-body">
          <SageJobsExporter showDeferred={deferredJobView} />
        </div>
      </div>
      <Nav bsStyle="tabs" activeKey={activeTab}>
        <NavItem eventKey={JOBS_TAB_KEY} onClick={viewJobsAction}>Jobs</NavItem>
        <NavItem
          eventKey={DEFERRED_JOBS_TAB_KEY}
          onClick={viewDeferredJobsAction}
        >
          Deferred
        </NavItem>
      </Nav>
      <div className="panel panel-default panel-tabbed">
        {
          jobView
            && (
            <React.Fragment>
              <JobInvoiceInbox />
              <hr />
              <JobInvoiceInboxLegend />
            </React.Fragment>
            )
        }
        {
          deferredJobView
          && <DeferredJobInbox />
        }
      </div>
    </div>
  );
};


InvoiceInbox.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    jobView: state.ticketInvoicing.jobView,
    deferredJobView: state.ticketInvoicing.deferredJobView,
  };
};


const mapDispatchToProps = {
  viewJobsAction: viewJobs,
  viewDeferredJobsAction: viewDeferredJobs,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withActiveTab = withProps((props) => {
  const { jobView, deferredJobView } = props;

  if (jobView) {
    return { activeTab: JOBS_TAB_KEY };
  } if (deferredJobView) {
    return { activeTab: DEFERRED_JOBS_TAB_KEY };
  }

  throw new Error(`InvoiceInbox: Unable to determine activeTab: ${jobView} ${deferredJobView}`);
});


const enhance = compose(
  withRedux,
  withActiveTab,
);


export default enhance(InvoiceInbox);
